import { render, staticRenderFns } from "./ignoreList.vue?vue&type=template&id=95a9cffc&scoped=true"
import script from "./ignoreList.vue?vue&type=script&lang=js"
export * from "./ignoreList.vue?vue&type=script&lang=js"
import style0 from "./ignoreList.vue?vue&type=style&index=0&id=95a9cffc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a9cffc",
  null
  
)

export default component.exports